// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AppEvent } from '@interfaces/interfaces';
import { SettingsService } from '@services/settings.service';

@Component({
    selector: 'app-token-invalid',
    templateUrl: './token-invalid.component.html',
    styleUrls: ['./token-invalid.component.scss'],
})
export class TokenInvalidComponent implements OnInit {
    tenantSupportEmail = '';
    tenantSupportPhone = '';
    @Output() signal: EventEmitter<AppEvent> = new EventEmitter();

    constructor(private readonly settingsService: SettingsService) {}

    async ngOnInit(): Promise<void> {
        ({ supportEmail: this.tenantSupportEmail, supportPhone: this.tenantSupportPhone } = await this.settingsService.getOemSettings());
    }
}
